import axios from 'axios';
import api from '../utils/api';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const publicApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export async function bootstrapContactSpace(token) {
  const { data } = await publicApi.post('/contact-space/session', { token });
  return data;
}

export async function getContactSpace() {
  const { data } = await publicApi.get('/contact-space/me');
  return data;
}

export async function authorizeContactApp(appId) {
  const { data } = await publicApi.post(`/contact-space/apps/${appId}/authorize`);
  return data;
}

export async function disconnectContactApp(appId) {
  const { data } = await publicApi.delete(`/contact-space/apps/${appId}`);
  return data;
}

export async function listContactIntegrations(contactId) {
  const { data } = await api.get(`/contacts/${contactId}/integrations`);
  return data;
}

export async function createContactSpaceLink(contactId) {
  const { data } = await api.post(`/contacts/${contactId}/space-link`);
  return data;
}
